<template>
  <div>
    <header v-if="showTitle" class="hero_container green" style="min-height: 140px;">
      <div class="container-fluid">
        <h1 style="padding-top: .5rem;">{{headerTitle}}</h1>
      </div>
    </header>

    <application :user="Selected.currentUser.get()" :header-attrs="headerAttrs" has-footer class="model-views app-content">
      <template #header>
        <div class="page-title">
          <h1>{{headerTitle}}</h1>
        </div>
      </template>

      <template #secondary-header>
        <router-view name="secondaryHeader" :breadcrumbs="breadcrumbs" ref="secondaryHeader"></router-view>
      </template>

      <main class="main-content">
        <router-view
          @queue-upload-for-deletion="queueUploadForDeletion($event)"
        ></router-view>
      </main>
    </application>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Selected from "./store/modules/selected";
import { Hash } from "../../common/interfaces/hashInterfaces";
import IBreadcrumb from "../../common/interfaces/breadcrumbInterfaces";
import {Area} from "./enums/area";
import {mapState} from "vuex";
import RefreshEntryDataBus from './buses/refreshEntryDataBus';

export default Vue.extend({
  data: function() {
    return {
      Selected
    };
  },
  created() {
    RefreshEntryDataBus.onRefresh(this.refreshSelectedEntry);
  },
  computed: {
    headerAttrs(): Hash {
      return {
        showCustomLogo: true
      };
    },
    showTitle(): boolean {
      // don't shown when $route.name is null to prevent header briefly appearing before current route has been parsed
      return this.isOneStop && this.$route.name && this.$route.name !== Area.entityDashboardListView && this.$route.name !== Area.userDashboardDetailView && !this.isDNR;
    },
    headerTitle(): string {
      return Selected.modelView.titleOrDefault;
    },
    ...mapState('breadcrumbStore', ['breadcrumbs'])
  },
  methods: {
    refreshSelectedEntry(): void {
      const selectedEntry = Selected.objectModelEntry.get();
      const publishedDetailView = Selected.publishedDetailView.get();

      if (!selectedEntry || !publishedDetailView) return;

      this.$store.dispatch('detailViewStore/fetchEntry', {
        detailViewId: publishedDetailView.detail_view_id,
        entryId: selectedEntry.id,
      }).then(([data]) => {
        selectedEntry.loadFromJson(data.entry);
      });
    },
    queueUploadForDeletion(upload) {
      // the secondary header is what uses saveObjectModelEntryMixin.ts to actually handle saving (incl. deleting uploads)
      this.$refs.secondaryHeader.queueUploadForDeletion(upload);
    },
  },
});
</script>
